
                  export default function (Component) {
                      Component.__source = "src/components/navBar.vue"
                  }
              